import { api } from "@/api/axios.ts";
import { ApiEmployeeEmploymentPayload } from "@/types/employees/employee-employment.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

export const apiEmployeeEmployment = {
  create: async function (id: number, payload: ApiEmployeeEmploymentPayload) {
    return api.post<ApiOperationResult>(`/api/v1/employees/${id}/employments`, payload);
  },
  update: async function (id: number, positionId: number, payload: ApiEmployeeEmploymentPayload) {
    return api.put<ApiOperationResult>(
      `/api/v1/employees/${id}/employments/${positionId}`,
      payload
    );
  },
  delete: async function (employeeId: number, employeePositionId: number) {
    return api.delete<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/employments/${employeePositionId}`
    );
  },
};
